module.exports = __webpack_public_path__ + "static/media/nightlight_legend.6f4cfa44.png";